import * as yup from 'yup';

export const supportMessageSchema = yup.object({
  subject: yup.string().min(2).max(100).required(),
  body: yup.string().min(2).max(1000).required(),
});
